import React from 'react';

const Header = () => {
  return (
    <header>
      <div className="title">
        <h1>9o OUR OCEAN CONFERENCE</h1>
        <h3>Στο Κοινωφελές Ίδρυμα Αθανάσιος Κ. Λασκαρίδης δεσμευόμαστε για το μέλλον των θαλασσών και τη βιωσιμότητα του πλανήτη μας!</h3>
      </div>
    </header>
  );
};

export default Header;